import { supabase } from '../lib/supabase.js';

// Video storage utilities for Supabase
export const videoStorage = {
  // Upload video file to Supabase storage
  async uploadVideo(file, vehicleId, videoType = 'general') {
    try {
      // Generate unique filename
      const timestamp = Date.now();
      const fileExt = file.name.split('.').pop();
      const fileName = `${vehicleId}-${videoType}-${timestamp}.${fileExt}`;
      
      // Upload to vehicle-videos bucket
      const { data, error } = await supabase.storage
        .from('vehicle-videos')
        .upload(fileName, file, {
          cacheControl: '3600',
          upsert: false
        });

      if (error) throw error;

      // Get public URL
      const { data: { publicUrl } } = supabase.storage
        .from('vehicle-videos')
        .getPublicUrl(fileName);

      return {
        success: true,
        url: publicUrl,
        fileName: fileName,
        path: data.path
      };
    } catch (error) {
      console.error('Video upload error:', error);
      return {
        success: false,
        error: error.message
      };
    }
  },

  // Delete video from storage
  async deleteVideo(fileName) {
    try {
      const { error } = await supabase.storage
        .from('vehicle-videos')
        .remove([fileName]);

      if (error) throw error;
      return { success: true };
    } catch (error) {
      console.error('Video deletion error:', error);
      return {
        success: false,
        error: error.message
      };
    }
  },

  // Get video URL from storage
  getVideoUrl(fileName) {
    const { data: { publicUrl } } = supabase.storage
      .from('vehicle-videos')
      .getPublicUrl(fileName);
    
    return publicUrl;
  },

  // Validate video file
  validateVideo(file) {
    const maxSize = 500 * 1024 * 1024; // 500MB
    const allowedTypes = ['video/mp4', 'video/webm', 'video/ogg', 'video/avi', 'video/quicktime', 'video/x-msvideo'];
    
    if (!file) {
      return { valid: false, error: 'No file selected' };
    }
    
    if (file.size > maxSize) {
      return { valid: false, error: 'File size must be less than 500MB' };
    }
    
    if (!allowedTypes.includes(file.type)) {
      return { valid: false, error: 'Invalid file type. Please upload MP4, WebM, OGG, AVI, or MOV files.' };
    }
    
    return { valid: true };
  },

  // Extract filename from URL
  getFileNameFromUrl(url) {
    if (!url) return null;
    const parts = url.split('/');
    return parts[parts.length - 1];
  }
};

export default videoStorage;
